/**
 * @generated SignedSource<<3e0c22b353b2883780e0958fa007d3db>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientFileLockFragment$data = {
  readonly id: string;
  readonly inContextOfAppointment: {
    readonly id: string;
  } | null;
  readonly lockRequestedAt: string | null;
  readonly lockRequestedBy: string | null;
  readonly lockedAt: string | null;
  readonly lockedBy: string | null;
  readonly patientId: string;
  readonly requestInContextOfAppointmentId: string | null;
  readonly " $fragmentType": "PatientFileLockFragment";
};
export type PatientFileLockFragment$key = {
  readonly " $data"?: PatientFileLockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientFileLockFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockRequestedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockRequestedBy",
      "storageKey": null
    },
    {
      "alias": "inContextOfAppointment",
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestInContextOfAppointmentId",
      "storageKey": null
    }
  ],
  "type": "PatientFileLock",
  "abstractKey": null
};
})();

(node as any).hash = "e4982102aea708e4b59ce9c25e7dce96";

export default node;
